export default __webpack_public_path__ + "static/media/sb2.68901300.jpeg";